import { motion } from "framer-motion";
import { Play, Pause, Music2 } from "lucide-react";
import { CONTENT } from "@/content";

export default function AudioPlayer({ playing, onToggle }) {
  const { title, artist } = CONTENT.music;

  return (
    <motion.div
      className="fixed bottom-5 right-5 z-[65] flex items-center gap-3 glass rounded-full pl-4 pr-2 py-2 max-w-[calc(100vw-2.5rem)]"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.2, duration: 0.8 }}
      data-testid="music-player"
    >
      <Music2 size={16} style={{ color: "var(--rose)" }} />

      <div className="leading-tight min-w-0">
        <p
          className="font-body text-xs uppercase tracking-[0.15em] truncate"
          style={{ color: "var(--alabaster)" }}
        >
          {title}
        </p>
        <p className="font-body text-[10px] truncate" style={{ color: "var(--muted-rose)" }}>
          {artist}
        </p>
      </div>

      {/* equalizer bars */}
      <div className="hidden sm:flex items-end gap-[3px] h-4 mx-1">
        {[0, 1, 2, 3].map((b) => (
          <motion.span
            key={b}
            className="w-[3px] rounded-full"
            style={{ background: "var(--rose)" }}
            animate={playing ? { height: [4, 15, 6, 16, 4] } : { height: 4 }}
            transition={{
              duration: 0.9,
              repeat: playing ? Infinity : 0,
              delay: b * 0.12,
            }}
          />
        ))}
      </div>

      <motion.button
        onClick={onToggle}
        className="relative flex items-center justify-center w-10 h-10 rounded-full shrink-0"
        style={{ background: "var(--rose)", color: "#0d0608" }}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.92 }}
        data-testid="music-toggle"
        aria-label={playing ? "Pause music" : "Play music"}
      >
        {playing && (
          <motion.span
            className="absolute inset-0 rounded-full"
            style={{ border: "1px solid var(--rose)" }}
            animate={{ scale: [1, 1.5], opacity: [0.6, 0] }}
            transition={{ duration: 1.8, repeat: Infinity, ease: "easeOut" }}
          />
        )}
        {playing ? (
          <Pause size={16} />
        ) : (
          <Play size={16} style={{ marginLeft: 2 }} />
        )}
      </motion.button>
    </motion.div>
  );
}
